import { Component, computed, input } from '@angular/core';

export type StatusPillVariant = 'success' | 'danger' | 'warning' | 'info' | 'neutral';

const VARIANT_CLASSES: Record<StatusPillVariant, { pill: string; dot: string }> = {
  success: { pill: 'bg-success-soft text-success', dot: 'bg-success' },
  danger: { pill: 'bg-danger-soft text-danger', dot: 'bg-danger' },
  warning: { pill: 'bg-warning-soft text-warning', dot: 'bg-warning' },
  info: { pill: 'bg-info-soft text-info', dot: 'bg-info' },
  neutral: { pill: 'bg-interactive text-text-secondary', dot: 'bg-text-secondary' }
};

@Component({
  selector: 'app-status-pill',
  imports: [],
  template: `
    <span
      class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium"
      [class]="pillClass()">
      @if (dot()) {
        <span class="size-1.5 shrink-0 rounded-full" [class]="dotClass()"></span>
      }
      <ng-content></ng-content>
    </span>
  `,
  styles: ``
})
export class StatusPillComponent {
  variant = input<StatusPillVariant>('neutral');
  dot = input(false);

  protected pillClass = computed(() => VARIANT_CLASSES[this.variant()].pill);
  protected dotClass = computed(() => VARIANT_CLASSES[this.variant()].dot);
}
